module.exports = __webpack_public_path__ + "static/media/9_Great_Taste.ec693581.png";